import Vue from 'vue';
import firebase from '@/plugins/firebase';
import Router from 'vue-router';

declare module 'vue/types/vue' {
  // 3. Declare augmentation for Vue
  interface Vue {
    $auth: Auth,
  }
}
interface State {
  uid: string | null,
  recently_logged_in_for: number,
  ready: boolean,
}
export class Auth extends Vue {
  state: State = Vue.observable({
    uid: null,
    ready: false,
    recently_logged_in_for: 0,
  });

  // uid: string | null = Vue.observable({});
  signIn({ email, params = {} } : {email: string, params?: {[key: string]: string}}) {
    return new Promise<string>(async (resolve, reject) => {
      const { currentUser } = firebase.auth();
      if (currentUser) {
        try {
          await currentUser.updateEmail(email);
        } catch (error) {
          // No worries. There is probably an account already.
        }
      }
      console.log('call signInRequest');
      firebase.app().functions('europe-west1').httpsCallable('auth-signInRequest')({
        email,
        url: window.location.href,
      }).then((result) => {
        console.log(result);
        window.localStorage.setItem('signInId', result.data.signInId);
        window.localStorage.setItem('signInSecret', result.data.signInSecret);
        this.waitForToken();
        resolve(result.data.signInSecret);
      });
    });
  }

  authenticate(data: any) {
    return firebase.app().functions('europe-west1').httpsCallable('auth-authenticate')(data).then(result => (result.data === 'ok' ? true : result.data));
  }

  signOut() {
    return new Promise((resolve, reject) => {
      firebase.auth().signOut().then(() => {
        this.state.uid = null;
        resolve();
      }).catch(error => reject(error));
    });
  }

  waitForToken() {
    const id = window.localStorage.getItem('signInId');
    if (!id) {
      return;
    }
    console.log(`Waiting for authentication: ${id}`);
    const authPublic = firebase.firestore().collection('authPublic').doc(id);
    authPublic.onSnapshot((snapshot) => {
      const data = snapshot.data();
      if (data && data.token) {
        firebase.auth().signInWithCustomToken(data.token).then(() => authPublic.delete()).then(() => {
          window.localStorage.removeItem('signInId');
        });
      }
    });
  }
}

export default function install(
  Vue: Vue.VueConstructor,
  {
    router,
    onUserChange,
  }: {
    router: Router,
    onUserChange: (userId: string | null, properties?: any) => void
  },
) {
  const auth = Vue.prototype.$auth = new Auth();
  Vue.component('login-form', require('./components/LoginForm.vue').default);
  router.addRoutes([
    {
      path: '/authenticate',
      name: 'authenticate',
      component: require('./components/Authenticate.vue').default,
    },
  ]);
  router.beforeEach((to, from, next) => {
    if (to.query.signin && to.name !== 'authenticate') {
      const signInId = window.localStorage.getItem('signInId');
      if (signInId === to.query.signin) {
        auth.authenticate({ id: to.query.signin, ...to.query }).then(() => {
          next({
            ...to,
            query: undefined,
          } as any);
        }).catch((error) => {
          console.error(error);
        });
      } else {
        router.push({ name: 'authenticate', query: to.query });
      }
      return;
    }
    next();
  });
  firebase.auth().onAuthStateChanged((user) => {
    auth.state.ready = true;
    if (user) {
      auth.state.uid = user.uid;
    } else {
      auth.state.uid = null;
    }
    onUserChange(auth.state.uid, user && {
      email: user.email,
      emailVerified: user.emailVerified,
      phoneNumber: user.phoneNumber,
    });
  });
  auth.waitForToken();
}
